import { ActionTimestamp } from "../../../action";
import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { SetEntry } from "../../../SetInventory/SetInventory";
import { ActionEntry } from "../../ActionEntries";

export const applyCostsSets = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newSets: Map<string, SetEntry>,
  _: ActionTimestamp[],
  buyAmount: number = 1,
) => {
  // Apply Costs (both bricks and sets)
  //
  // These steps are split so that entire validation is completed prior to application
  // Avoid issue where partial application happens then invalid costs are met
  for (let i = 0; i < action.cost.length; i++) {
    const costEntry = action.cost[i];
    const trueCost =
      (costEntry.baseChangeValue + action.costIncrement * action.costScale) *
      buyAmount;

    // Default to "brick" if type not specified (backward compatibility)
    const costType = costEntry.type || "brick";

    if (costType === "brick") {
      // Apply brick costs
      const currBrick = newBricks.get(costEntry.brickId)!;
      currBrick.amount -= trueCost;

      if (currBrick.amount < 0) return null;
    } else if (costType === "set") {
      // Apply set costs (sets can't go negative)
      const currSet = newSets.get(costEntry.brickId)!; // brickId field contains set ID
      currSet.count -= trueCost;

      if (currSet.count < 0) return null;
    }
  }

  return { newBricks, newSets };
};
